module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGc0189645430acca8d357caeabdb4f886.c0189645.png";